import RedeemBenefitModal from './RedeemBenefitModal'

export default RedeemBenefitModal
